var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/util/reduced_motion.tsx";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
// Like react-motion's Motion, but reduces all animations to cross-fades
// for the benefit of users with motion sickness.
import React from 'react';
import { Motion } from 'react-motion';
const stylesToKeep = ['opacity', 'backgroundOpacity'];
const extractValue = value => {
  // This is either an object with a "val" property or it's a number
  return typeof value === 'object' && value && 'val' in value ? value.val : value;
};
const ReducedMotion = ({
  style = {},
  defaultStyle = {},
  children
}) => {
  Object.keys(style).forEach(key => {
    if (stylesToKeep.includes(key)) {
      return;
    }
    // If it's setting an x or height or scale or some other value, we need
    // to preserve the end-state value without actually animating it
    style[key] = defaultStyle[key] = extractValue(style[key]);
  });
  return /*#__PURE__*/React.createElement(Motion, {
    style: style,
    defaultStyle: defaultStyle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }, children);
};
export default ReducedMotion;